export default {"src":"/_next/static/media/gps.a1fd3d00.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};